module.exports = __webpack_public_path__ + "img/hardcore-39.9bebd428.png";